@import ../../styles/helpers


.header 
    display: flex
    flex-direction: column
    width: 100%
    padding: 10px
    &__title_row
        width: 100%
        display: flex
        justify-content: space-between
        align-items: center
        padding-bottom: 20px
        border-bottom: 1px solid $bordercolor

    &__title
        font-size: 30px
        line-height: 38px
        margin-right: 15px
        margin-left: 10px
        font-weight: 500

    &__title_number
        font-size: 24px
        line-height: 28px
        color: #FBBA2F
    &__title_new
        display: flex
        align-items: center
        cursor: pointer
    &__search
        position: relative
        flex-shrink: 0
        margin-top: $internal_margin
        margin-bottom: 20px
        height: 50px
        svg
            width: 30px
            height: 30px


.container
    margin-top: 0px
    position: relative

    &__bottomGradient
        background: linear-gradient(180deg, #11141B 5.76%, rgba(17, 20, 27, 0.8) 41.96%, rgba(17, 20, 27, 0.56311) 67.2%, rgba(17, 20, 27, 0) 97.72%)
        transform: rotate(180deg)
        width: 100%
        height: 200px
        position: absolute
        bottom: 0px

.input
    width: 100%
    height: 63px
    padding: 0 42px 0 54px
    background: none
    border-radius: 25px
    color: #FFFFFF
    background-color: #1B2028
    transition: border-color .2s
    font-size: 15px
    line-height: 18px

.friends_container
    display: flex
    width: 100%
    height: fit-content
    gap: 5px
    flex-direction: column

.friendLink
    transition: transform 0.1s
    position: relative
    display: flex
    justify-content: center
    align-items: center
    div
        background-color: $dark_contrast
        border-radius: 100%
        width: $icon_size
        height: $icon_size
    img
        fill: white
        width: $icon_size
        height: $icon_size
    &:not(.simple)
        justify-content: start
